<template>
  <div id="stepFour">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
      <div class="container">
        <h2>Confirmation of Responsibilities</h2>
        <p>Please Take a minute to read the Student Volunteer Eligibility Requirements and Responsibilities below:</p>
      </div>
      <div class="container mt-4">
        <div id="eligibility" class="row">
          <div class="col">
            <h2>Eligibility</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <h3>Age</h3>
            <p>Applicants must be 18 years of age or older (on or before 15 May 2024).</p>
          </div>
          <div class="col-md-12 col-sm-12">
            <h3>Full Time Student Status</h3>
            <p>Applicants must be/have been enrolled as a full-time high school, undergraduate, or graduate students for at least one semester between June 2023 and September 2024.</p>
          </div>
        </div>
      </div>
      <div class="container mt-4">
        <div id="expectations" class="row">
          <div class="col">
            <h2>Expectations</h2>
          </div>
        </div>
       </div>
      <div class="container mt-4">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <p>Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer Program after accepting a position.</p>
            <p>Student Volunteers and Team Leaders will serve the conference in-person shifts (on-site at SIGGRAPH 2024 in Denver).</p>
            <p>Student Volunteers commit to volunteering about 25 hours to provide operational support for SIGGRAPH 2024 in pre-conference shifts or the in-person conference. In exchange for their service and enthusiasm, Student Volunteers receive the highest level of registration for the conference, networking opportunities, and a number of exclusive Student Volunteer-only benefits.</p>
            <p>Team Leaders are expected to volunteer about 60 hours to provide operational and logistical support for SIGGRAPH 2024 pre-conference shifts or the in-person conference. In exchange for their service and enthusiasm, Team Leaders receive the highest level of registration for the conference, networking opportunities, and a number of exclusive Student Volunteer-only benefits.</p>
          </div>
          <div class="col-md-12 col-sm-12">
            <h3>For In-person Volunteers</h3>
            <ul style="list-style-type:square; padding-left: 15px">
              <li>You are expected to participate in SIGGRAPH 2024 all day from July 28 - August 1 2024 in Denver.</li>
              <li>DO NOT plan to depart the Colorado Convention Center earlier than 6 pm (GMT-8) on 1 August 2024.</li>
              <li>No housing or accommodation will be provided to Team Leaders or Student Volunteers.</li>
              <li>Student Volunteers and Team Leaders can opt for financial assistance on their application form. You will be notified if you are awarded financial aid and the amount with the result of your student volunteer application.</li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <p>More details on what involves being a Student Volunteer will be provided during the upcoming months.</p>
            <p>If you have any questions regarding the program and processes, please email <a href="mailto:sv-s2024@siggraph.org">sv-s2024@siggraph.org</a></p>
          </div>
          <div class="col-md-12 col-sm-12">
            <h3>Attend Mandatory Orientation</h3>
            <p>Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer Program after accepting a position.</p>
          </div>
          <div class="col-md-12 col-sm-12">
            <p><b>IMPORTANT.</b> More details on what involves being a in-person Student Volunteer will be provided upon acceptance. We encourage you to visit our  <a href="https://s2024.siggraph.org/program/student-volunteers/">FAQs</a> section to stay abreast of the latest updates regarding the Student Volunteer Program.</p>
          </div>
        </div>
      </div>
      <div class="container mt-4">
        <div id="benefits" class="row">
          <div class="col">
            <h2>Benefits</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <h3>Full Conference Registration</h3>
            <p>Enjoy all of the latest and greatest this amazing conference has to offer! SIGGRAPH offers many opportunities to explore the latest innovations when you are off-shift.</p>
            <h3>Student Volunteer Special Sessions</h3>
            <p>Hear top professionals in the industry and academia (some of them former Student Volunteers) speak about tips, tricks, and job opportunities at exclusive “Student Volunteers-only” sessions before SIGGRAPH 2024!</p>
            <h3>S3 Résumé and Reel Review Sessions</h3>
            <p>Polish your reel and résumé, and get some professional feedback (virtually and in-person) to land your dream job! Space is limited. This program is made possible by the SIGGRAPH Student Services Committee (S3).</p>
            <h3>Professional Development</h3>
            <p>Expand your knowledge outside the classroom through leadership, mentoring, and diversity & inclusion sessions tailored specially for student volunteers.</p>
            <h3>Networking</h3>
            <p>Participate in the many events and get-togethers we will organize prior to and during the conference. Meet students from all over the globe who share your passion for computer graphics and interactive techniques!</p>
          </div>
        </div>
      </div>
      <div class="container mt-4">
        <div id="deadlines" class="row">
          <div class="col">
            <h2>Deadlines</h2>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br/>
            <p>Please comply with the submission deadlines and ensure you submit your application by the appropriate day and time. We will not accept any late applications or make any exceptions for students due to miscalculation of the application deadline. Thank you for your understanding.</p>
            <p>Please adjust your spam filter so messages with the ‘siggraph.org’ domain will not be placed in your junk-mail folder.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>{{ formattedDate(applicationTlEndDate) }}:</strong> Team Leader Applications Deadline</h3>
            <p>Only open to students who have previously served as Student Volunteers. Please complete the regular Student Volunteer application and the Team Leader essays on the application by 22:00 UTC/GMT.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>Mid-February 2024:</strong> Team Leader Acceptance Notification</h3>
            <p>Team Leader application results will be sent in mid-February 2024. You will receive an email notification at the address you provided in your application. Applicants who are not accepted as Team Leaders will still be considered for Student Volunteer positions.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>{{ formattedDate(applicationEndDate) }}:</strong> Student Volunteer Application Deadline</h3>
            <p>The Student Volunteer application must be completed by 22:00 UTC/GMT  (convert to your time zone).  Please note you will be required to upload proof of full-time student status (e.g., transcript, proof of enrollment, etc.). We recommend you allow ample time to gather this information from your institution before the due date. Without this documentation, your application will be marked as incomplete.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>Late April 2024:</strong> Student Volunteer Acceptance Notification</h3>
            <p>Student Volunteer application results will be sent in late April 2024. You will receive an email notification at the address you provided in your application.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3>Professional References</h3>
            <p>References will be contacted after applications close.</p>
          </div>
        </div>
      </div>
      <div class="container mt-4">
        <div id="questions" class="row">
          <div class="col">
            <h2>Questions</h2>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <p>We encourage you to visit our <a href="https://s2024.siggraph.org/program/student-volunteers/">FAQ</a> to stay abreast of the latest updates regarding the Student Volunteer Program.</p>
            <p>If your question is not in the FAQs, send us an email to <a href="mailto:sv-s2024@siggraph.org">sv-s2024@siggraph.org</a></p>
          </div>
        </div>
      </div>
      <div class="container">
        <h2>Terms and Responsibilities Agreement</h2>
        <br/>
        <p>I have read and understood the Student Volunteer Eligibility Requirements and Responsibilities. I certify that I am eligible to volunteer and willing to comply with the responsibilities described.</p>
        <b-form-group class="mt-4">
          <b-form-checkbox id="acceptedTerms" v-model="acceptedTerms">
            I Agree
          </b-form-checkbox>
        </b-form-group>
        <h2>Privacy Policy Agreement</h2>
        <br/>
        <p>I have read and accept the <a href="https://www.acm.org/about-acm/privacy-policy">ACM Privacy Policy</a></p>
        <b-form-group class="mt-4">
          <b-form-checkbox id="acceptedPrivacy" v-model="acceptedPrivacy">
            I Agree
          </b-form-checkbox>
        </b-form-group>
        <h2>Media Release Agreement</h2>
        <br/>
        <p>I agree permission for ACM/SIGGRAPH and its agents or employees to take and use photographs and/or video taken of me for use in promotional and educational electronic, video, and print materials for the SIGGRAPH organization.
          Furthermore, I authorize the use of my name, likeness, and voice for all SIGGRAPH Conference and organization promotion deemed appropriate and necessary by ACM/SIGGRAPH.</p>
        <p>I hereby waive any right of privacy and the right to inspect or approve the finished photographs or video that may be used in conjunction with such use now or in the future, whether that use is known to me or unknown.
          I also waive any right to royalties or other compensation arising from or related to the use of said photographs/video created for this purpose.</p>
        <p>I have read this release before accepting the conditions below, and I fully understand the contents, meaning, and impact of this release.
          I understand that I am free to address any specific questions regarding this release by submitting those questions in writing prior to signing, and I agree that my failure to do so will be interpreted as a free and knowledgeable acceptance of the terms of this release.</p>
        <b-form-group class="mt-4">
          <b-form-checkbox id="acceptedMediaRelease" v-model="mediaReleaseAgreement">I Agree</b-form-checkbox>
        </b-form-group>
        <div v-if="isValid&&!isOverWordCount" style="border: #FEE800 10px solid; background: white; color: black">
          <h3 style="color: red; display: inline;">Notice:</h3><h3 style="display: inline;"> Once you submit, you will no longer be able to edit or change your application.</h3>
        </div>
        <div v-else-if="!isOverWordCount" style="border: #FEE800 10px solid; background: white; color: black">
          <h3 style="margin-top: 8px">Notice: You have some fields that need to be filled out before you can complete your application.</h3>
          <ul >
            <li style="font-size: 18px" v-for="invalid in invalidFields">{{ invalid }}</li>
          </ul>
        </div>
        <div v-else style="border: #FEE800 10px solid; background: white; color: black">
          <h3 style="margin-top: 8px">Notice: the following fields are over the word limit, adjust your responses in order to submit. </h3>
          <ul >
            <li style="font-size: 18px" v-for="invalid in overWordCount">{{ invalid }}</li>
          </ul>
        </div>
        <b-form-group>
          <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-sm float-sm-left" @click="previousStep">Previous Step</button>
          <button type="submit" :disabled="disabledFinish" class="btn arrow-btn-primary btn-sm float-sm-right" @click="nextStep">Save and Finish</button>
        </b-form-group>
      </div>
    </b-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import router from '@/router'

export default {
  name: 'AppStepFour',
  data () {
    return {
      disabled: false,
      acceptedTerms: false,
      acceptedPrivacy: false,
      mediaReleaseAgreement: false
    }
  },
  computed: {
    ...mapGetters('application', ['isValid', 'invalidFields', 'isOverWordCount', 'overWordCount']),
    ...mapState('application', ['isLoaded', 'isLoading']),
    ...mapState(['applicationTlEndDate', 'applicationEndDate']),
    disabledFinish: function () {
      return !this.acceptedTerms || !this.mediaReleaseAgreement || !this.isValid || !this.acceptedPrivacy || this.isOverWordCount
    }
  },
  methods: {
    formattedDate: function (date) {
      return moment(date).tz('UTC').format('D MMMM YYYY')
    },
    nextStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.dispatch('application/finish').then(() => {
          this.disabled = false
        })
      }
    },
    previousStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 3)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepThree' })
          this.disabled = false
        }).catch(err => {
          console.log(err.message)
          this.disabled = false
        })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.$store.dispatch('application/save')
        } else if (this.$store.state.application.step !== 4) {
          router.push('/application/' + this.$store.state.application.step.toString())
        }
      })
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/application/StepFour.vue